export const api = {
  evoucherListing: '/evoucher',
  evoucherByID: '/evoucher/',
  evoucherBySaleID: '/evoucher/get-by-sale',
  evoucherActivationRequest: '/evoucher/activate',
  evoucherRedeemByEvoucherID: '/evoucher/redeem',
  evoucherDownloadReceipt: '/evoucher/download-receipt',
}
